import EmblaCarousel from "embla-carousel";
import Fade from "embla-carousel-fade";
import ClassNames from "embla-carousel-class-names";
import Autoplay from "embla-carousel-autoplay";
import { setupLazyLoadImages, setupLazyLoadVideos, setupVideoPlayback } from "./embla-lazyload.js";
import { emblaDots } from "./embla-dots-navigation.js";

const emblaHeroCarousel = () => {
    const emblaNodes = document.querySelectorAll(".embla-hero-carousel");

    if (!emblaNodes.length) return;

    let loop = true;
    if (emblaNodes.length > 1) {
        loop = true;
    }
    const delay = 6000;

    const plugins = [
        Fade(),
        ClassNames(),
        Autoplay({
            delay: delay,
            stopOnInteraction: false,
        })
    ];

    const options = {
        loop: loop,
        dragThreshold: 5,
        duration: 60,
    };

    emblaNodes.forEach((node) => {
        const emblaApi = EmblaCarousel(node.querySelector('.embla__viewport'), options, plugins);

        node.style.setProperty("--duration", delay / 1000 + "s");

        const loadImages = setupLazyLoadImages(emblaApi);
        const loadVideos = setupLazyLoadVideos(emblaApi);
        const videoPlayback = setupVideoPlayback(emblaApi);

        emblaApi
            .on('slidesInView', () => {
                // Load images & videos when visible in viewport
                loadImages();
                loadVideos();

                // Play/pause videos when visible in viewport
                videoPlayback();
            });

        emblaDots(emblaApi, node.querySelector('.embla__dots'));
    });
};

export { emblaHeroCarousel };
